export function getView(group) {
  return group.members.length > 1 ? 'Multiple' : 'Single'
}
